<div class="row  justify-content ">

  <div class="col-12 autopartage-search-block">

    
    <div class="row ">
      <div class="col-12 ">
        <app-search-book-form [stations]="stationList" title='Réserver un véhicule' [mapStationSelected]="mapStationSelected"
          (stationChanged)="stationChangedHandler($event)"></app-search-book-form>
      </div>

    </div>
  </div>
    <!-- mont des avalois -->
  <div *ngIf="isMontDesAvaloirs === true" class="col-12 margin-block">
    <app-car-bloc-autopartage></app-car-bloc-autopartage>
  </div>
   <!-- avantages -->
  <div class="col-12 margin-block">
    <app-info-bloc-autopartage></app-info-bloc-autopartage>
  </div>
  <!-- comment ca marche -->
  <div class="col-12 margin-block">
    <app-ccm-autopartage></app-ccm-autopartage>
  </div>

</div>
